import Layers from "slotworks/graphics/layers/layers";
import canvasManager from "slotworks/graphics/canvas/canvas-manager";

const CANVAS_OUTLINE_THICKNESS: number = 500;
const CANVAS_OUTLINE_COLOR: string = "#00000099";

type TintScenes = {
    layer: Layers, scenes: string[];
};

class SGBackgroundShadeComponent {

    private config: TintScenes[] = [
        { layer: Layers.CelebrationContent, scenes: ["bigwin", "megabigwin", "hugebigwin"] },
        { layer: Layers.Prompts, scenes: ["freespinswin", "freespinssummary"] }
    ];

    init() {
        this.config.forEach(data => {
            data.layer.onSceneEnter.add((scene: string) => {
                if (data.scenes.indexOf(scene) !== -1) {
                    this.showCanvasOutline();
                }
            });
            data.layer.onSceneExit.add((scene: string) => {
                if (data.scenes.indexOf(scene) !== -1) {
                    this.resetCanvasOutline();
                }
            });
        });
    }

    private showCanvasOutline(): void {
        canvasManager.canvas.style.outline = `${CANVAS_OUTLINE_THICKNESS}px solid ${CANVAS_OUTLINE_COLOR}`;
    }

    private resetCanvasOutline(): void {
        canvasManager.canvas.style.outline = 'none';
    }


}

export default new SGBackgroundShadeComponent();
